import styled from 'styled-components';

export const LiveArenaWidgetMainContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    /* border: 1px solid ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
    border-radius: 3px;
    box-sizing: content-box; */
    margin: 30px 25px 0 25px;
    cursor: pointer;

    background: url(${props => props.theme.images.liveArena.liveArenaWidget.background.toString()});
    background-position: center;

    height: 70px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 50px;
        margin: 6px 4px 0 4px;
    }
`;
